import { Card, Table } from "reactstrap";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import NoDataFoundIcon from "Assets/Icons/NoDataFoundIcon";
// import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import styled from "styled-components";
import "./studentAttendance.css";
import LineGraph from "Pages/StudentPortfolio/StudentLOPSection/LineGraph";
// import { returnRiskSegment } from "Pages/BranchHealth/BranchHealthTable";
// import BarGraph from "Pages/BranchHealth/Student/BarGraph";
export const RiskStyledDiv = styled<any>("div")`
  background-color: ${(props: any) => props.color};
  border-radius: 4px;
  padding: 4px;
  width: fit-content;
`;
export const RiskStyledDSpan = styled<any>("span")`
  color: ${(props: any) => props.color};
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
`;
interface IStudentAttendanceTable {
  searchedFaculty?: any;
  mode?: string;
  tableloading?: any;
  tableData?: any;
  filterState?: any;
  barArray?: any;
  tableHeading?: any;
  barData?: any;
  barLabel?: any;
}
const StudentAttendanceTable = ({
  tableHeading,
  tableData,
  barArray,
}: //   barData,
//   barLabel,
IStudentAttendanceTable) => {
  const renderColumnItem = (item: any, column: any) => {
    let returnItem;
    if (column.value == "month") {
      returnItem = (
        <td className="border text-center">
          <strong className="monthCamelCase">
            {item[column.value].split("_")[0].substring(0, 1)}
            {item[column.value].split("_")[0].substring(1, 3).toLowerCase()}
            {"'"}
            {item[column.value].split("_")[1]}
          </strong>
        </td>
      );
    } else {
      returnItem = item["subjects"][column.value] ? (
        <td className="border text-center">
          <strong>
            {item["subjects"][column.value]["attendantClassCount"]}
          </strong>
          /{item["subjects"][column.value]["totalClassScheduled"]}
        </td>
      ) : (
        <td className="border text-center">-</td>
      );
    }
    return returnItem;
  };
  //   const renderColumn = (item: any, column: any) => {
  //     console.log(
  //       item,
  //       column,
  //       item["subjects"],
  //       column.value,
  //       "column.value",
  //       item["subjects"][column.value]
  //     );
  //     switch (column.value) {
  //       case "month":
  //         return (
  //           <td className="border text-center">
  //             <strong className="monthCamelCase">
  //               {item[column.value].split("_")[0].substring(0, 1)}
  //               {item[column.value].split("_")[0].substring(1, 3).toLowerCase()}
  //               {"'"}
  //               {item[column.value].split("_")[1]}1
  //             </strong>
  //           </td>
  //         );

  //       case "Maths":
  //       case "Mathematics":
  //       case "SST":
  //       case "Physics":
  //       case "Chemistry":
  //       case "Botany":
  //       case "Zoology":
  //       case "Biology":
  //       case "Mental Ability":
  //       case "MAT":
  //       case "English":
  //       case "Social Science":
  //         return item["subjects"][column.value] ? (
  //           <td className="border text-center">
  //             <strong>
  //               {item["subjects"][column.value]["attendantClassCount"]}
  //             </strong>
  //             /{item["subjects"][column.value]["totalClassScheduled"]}
  //           </td>
  //         ) : (
  //           <td className="border text-center">NA</td>
  //         );

  //       default:
  //         return <td className="border text-center">{item[column.value]}</td>;
  //     }
  //   };
  return (
    <div className="m-0 overflow-auto">
      <Card className="mb-0">
        <div className="tableFixHead">
          {tableData && tableData.length === 0 ? (
            <div className="mt-4 mb-8">
              <NoResultFoundSearch
                primaryMessage="No data present"
                secondaryMessage={
                  "There is either no data available or the system is currently in the process of syncing data."
                }
              >
                <NoDataFoundIcon />
              </NoResultFoundSearch>
            </div>
          ) : (
            <div className="d-flex flex-column mainContainerForGraphTable">
              <div className="graphHeightBarDV">
                <LineGraph
                  mode="attendance"
                  linedata={tableData}
                  barArray={barArray}
                />
              </div>
              {/* <div className="graphHeightBarDV">
                <BarChart data={tableData} barLabel={barArray} />
              </div> */}
              <Table
                responsive
                className="table table-hover tableSideHead tableBodyMain attendancetablemain"
              >
                <tbody>
                  {tableHeading.map((item: any, index: number) => (
                    <tr key={index}>
                      {tableData.map((el: any) => renderColumnItem(el, item))}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </div>
      </Card>
    </div>
  );
};
export default StudentAttendanceTable;
